var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-cascader',{ref:"cascader",staticClass:"diquClass",attrs:{"placeholder":_vm.placeholder,"props":_vm.ownRegionProps,"collapse-tags":"","options":_vm.ownRegionList,"clearable":"","size":"medium"},model:{value:(_vm.ownRegion),callback:function ($$v) {_vm.ownRegion=$$v},expression:"ownRegion"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }